import React, { FC, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { Button } from '@wmgtech/legato'
import { IProductForm } from '../types'
import { NEW_PRODUCT_ID } from 'modules/ProjectEdit/constants'
import { AddButtonProps } from './add-button.props'

export const AddButton: FC<AddButtonProps> = ({ append, disabled }) => {
  const { watch, setValue, getValues } = useFormContext<IProductForm>()

  const handleAddItem = useCallback(() => {
    const products = getValues('products')
    append({
      active: false,
      campaign_id: getValues(`products.${0}.campaign_id`),
      configuration: 'single',
      dsp_updates: false,
      id: NEW_PRODUCT_ID,
      name: '',
      parent_id: '',
      publish_date: '',
      radio_updates: false
    })
    setValue('editRow', products.length)
  }, [append, getValues, setValue])

  return (
    <Button
      containerStyle="outline"
      secondaryIcon="circle-plus"
      colorType="info"
      disabled={typeof watch('editRow') !== 'undefined' || disabled}
      onClick={handleAddItem}
      data-testid="add-product-button"
    >
      Add Product
    </Button>
  )
}
